import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/fieldconfig.interface';

@Component({
  selector: 'form-date-time',
  templateUrl: './form-date-time.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormDateTimeComponent implements Field, OnInit {
  config: FieldConfig;
  group: FormGroup;
  formattedDateTime: string = '';
  wid: string;

  constructor(private _cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.wid = `${this.config['name']}${this.config['id']}-widget`;

    const now = new Date();
    const estOffset = -5 * 60; // EST is UTC-5
    const estDate = new Date(now.getTime() + (now.getTimezoneOffset() + estOffset) * 60000);

    const dd = ('0' + estDate.getDate()).slice(-2);
    const mm = ('0' + (estDate.getMonth() + 1)).slice(-2);
    const yyyy = estDate.getFullYear();
    let hh = estDate.getHours();
    const mins = ('0' + estDate.getMinutes()).slice(-2);
    const secs = ('0' + estDate.getSeconds()).slice(-2);
    const ampm = hh >= 12 ? 'PM' : 'AM';
    hh = hh % 12;
    hh = hh ? hh : 12;
    const hhStr = ('0' + hh).slice(-2);
    this.formattedDateTime = dd + '-' + mm + '-' + yyyy + ', ' + hhStr + ':' + mins + ':' + secs + ' ' + ampm + ' EST';

    const formControl = this.group.controls[this.config.name] as FormControl;
    if (formControl) {
      const year = estDate.getFullYear();
      const month = ('0' + (estDate.getMonth() + 1)).slice(-2);
      const day = ('0' + estDate.getDate()).slice(-2);
      const hours = ('0' + estDate.getHours()).slice(-2);
      const minutes = ('0' + estDate.getMinutes()).slice(-2);
      const seconds = ('0' + estDate.getSeconds()).slice(-2);
      formControl.setValue(year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds);
      formControl.markAsTouched();
      formControl.markAsDirty();
    }

    this._cdr.markForCheck();
  }
}
